import { render, staticRenderFns } from "./PerformanceDetail.vue?vue&type=template&id=31735f4a&scoped=true&"
import script from "@/views/PerformanceShop/PerformanceDetail/PerformanceDetail.ts?vue&type=script&lang=ts&"
export * from "@/views/PerformanceShop/PerformanceDetail/PerformanceDetail.ts?vue&type=script&lang=ts&"
import style0 from "@/views/PerformanceShop/PerformanceDetail/PerformanceDetail.scss?vue&type=style&index=0&id=31735f4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31735f4a",
  null
  
)

export default component.exports